import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import enUS from "./en.json";
import zhCN from "./zh.json";

i18n
.use(LanguageDetector)
.use(initReactI18next)
.init({
    resources: {
        en: {
            translation: enUS,
        },
        zh: {
            translation: zhCN,
        },
    },
    fallbackLng: "zh",
    debug: false,
    interpolation: {
        escapeValue: false,
    }
})

export default i18n;